import { render, staticRenderFns } from "./reset-password.vue?vue&type=template&id=54c1cd05"
import script from "./reset-password.ts?vue&type=script&lang=js&external"
export * from "./reset-password.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports